import React from 'react'
import { BulkDeleteWithConfirmButton, Datagrid } from 'react-admin'
import Exporter from 'services/csv/exporter'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ReorderableList from 'ui-shared/DraggableList/ReorderableList'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'
import { useKGetList } from 'services/hooks/useKGetList'
import {
  LinkedCustomerUser,
  LinkedOrganization,
} from 'services/api/entities/catalog/types'
import OrganizationsEmailField from './OrganizationsEmailField'
import { ProductPackageWithMinAndMaxQuantity } from 'resources/catalog/packages/eventPackage/package/common'
import CustomerEmailChip from './CustomerEmailChip'
import { APIEntity } from 'services/api/entities'
import { BaseListProps } from '../CatalogItemBaseList'
import { useKResource } from 'services/hooks/useKResource'

type Props = BaseListProps & {
  boundEntity: APIEntity
}

const BasePackageList: React.FC<Props> = ({ boundEntity, ...props }) => {
  const resource = useKResource<APIEntity>()

  const products = useKGetList<
    ProductPackageWithMinAndMaxQuantity & {
      customersFull: LinkedCustomerUser[]
      organizationsFull: LinkedOrganization[]
    }
  >(boundEntity)

  return (
    <SectionWrapper title={`resources.${resource}.sectionName`}>
      <ReorderableList
        pagination={false}
        bulkActionButtons={
          <BulkDeleteWithConfirmButton mutationMode="optimistic" />
        }
        exporter={Exporter()}
        resource={resource}
        {...props}
      >
        <Datagrid rowClick="edit">
          <LocalizedTextField source="name" />
          <LocalizedTextField source="status" sortable={false} />
          <CustomerEmailChip arrayFieldSource={products} />
          <OrganizationsEmailField arrayFieldSource={products} />
        </Datagrid>
      </ReorderableList>
    </SectionWrapper>
  )
}

export const buildPackageList =
  (boundEntity: APIEntity): React.FC<BaseListProps> =>
  (props) =>
    <BasePackageList boundEntity={boundEntity} {...props} />
